export default "__VITE_ASSET__CNcrfzq5__"